import { useEffect, useState } from "react";
import { GuidePostService } from "@oldDashboard/legacyServices/guide-posts/guidePostService";
import { setCumulativeInvoiceAction } from "@oldDashboard/legacyActions/dashboardClient";

interface LaunchTileProps { launchSelected: String, timePeriodSelected: String, searching: boolean }
const useCumulativeInvoice = (props:LaunchTileProps) => {

    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        fetchCumulativeInvoice();
    }, [props.searching, props.launchSelected]);

    const fetchCumulativeInvoice = async() => {
        setIsLoading(true);
        try {
            const service = new GuidePostService();
            const response = await service.getCumulativeInvoice(props.launchSelected, props.timePeriodSelected);
            if (response) {
                setCumulativeInvoiceAction(response);
            }
        } catch (error: any) {
            console.log("ERROR ", error)
        } finally {
            setIsLoading(false);
        }
    }

    return { isLoading, fetchCumulativeInvoice }
}

export default useCumulativeInvoice